import React, { PureComponent } from 'react';
import ReactTable from 'react-table';

import { TableWrapper } from 'modules/list/table';

export default class AddonInfo extends PureComponent {
  render() {
    const { addonInfo } = this.props;

    const tableColumns = [
      {
        columns: [
          {
            Header: 'Addon Course',
            accessor: 'addon_course',
          },
          {
            Header: 'Addon Type',
            accessor: 'addon_type',
          },
          {
            Header: 'Addon Name',
            accessor: 'addon_name',
          },
          {
            Header: 'Comments',
            accessor: 'comments',
          },
        ],
      },
    ];
    return (
      <React.Fragment>
        <TableWrapper>
          <ReactTable
            data={addonInfo}
            className="-striped -highlight"
            manual
            showPaginationTop
            showPageSizeOptions={false}
            filterable={false}
            sortable={false}
            resizable={false}
            defaultPageSize={3}
            columns={tableColumns}
            style={{ textAlign: 'center', height: 110 }}
          />
        </TableWrapper>
      </React.Fragment>
    );
  }
}
